module.exports = __webpack_public_path__ + "img/step3-b.641c1c54.png";